import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocales } from 'expo-localization';
import resources from './resources';
import { updateDayjsLocale } from './dayjs-config';

// Get device language
const deviceLanguage = getLocales()[0]?.languageCode || 'en';

// Export the device language to use elsewhere
export const DEFAULT_LANGUAGE = deviceLanguage;

// Initialize i18next first so we can use it for translations
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: deviceLanguage,
    fallbackLng: 'en',
    // Set default namespace to 'default'
    defaultNS: 'default',
    // Define available namespaces
    ns: ['default', 'domain'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    compatibilityJSON: 'v4',
    // Debug mode - set to false in production
    debug: __DEV__,
    // Handle pluralization more elegantly
    pluralSeparator: '_',
    keySeparator: '.',
  });

// Set initial dayjs locale
updateDayjsLocale(deviceLanguage);

// List of supported languages (native names). The "default/system" label must be translated at render-time
// (i18n.t here is not reactive and will not update UI until a full reload).
export const SUPPORTED_LANGUAGES = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  pt: 'Português',
  de: 'Deutsch',
  // Add more languages as needed
};

/**
 * Change the application language
 * @param language - Language code or 'default' for device language
 */
export const changeLanguage = (language: string | 'default') => {
  const targetLanguage = language === 'default' ? deviceLanguage : language;
  
  const result = i18n.changeLanguage(targetLanguage);
  result.then(() => {
    // Update dayjs locale when language changes
    updateDayjsLocale(targetLanguage);
  });
  
  return result;
};

export default i18n;
